// import React from "react";

// const services = [
//   {
//     title: "Open Air Photo Booth",
//     desc: "Timeless, elegant, and always a hit — perfect for weddings, birthdays, and private events.",
//     icon: "🕺",
//   },
//   {
//     title: "360° Video Booth",
//     desc: "Step into the spotlight! Capture cinematic slow-motion videos that are instantly shareable.",
//     icon: "🎥",
//   },
//   {
//     title: "Glam Booth",
//     desc: "Our Black & White Glam Booth delivers that iconic Kardashian-inspired, red-carpet-ready look.",
//     icon: "✨",
//   },
//   {
//     title: "Enclosed LED Booth",
//     desc: "LED Inflatable Photo Booth — a glowing, customizable space your guests will love.",
//     icon: "💡",
//   },
//   {
//     title: "Green Screen",
//     desc: "Transform your moments into cinematic magic with creative backgrounds that match your theme.",
//     icon: "🎬",
//   },
// ];

// export default function ServicesSection() {
//   return (
//     <section
//       id="services"
//       className="py-20 bg-slate-900 text-white relative overflow-hidden"
//     >
//       <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-slate-950 to-transparent pointer-events-none" />
//       <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
//         <div className="text-center mb-12">
//           <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
//             Services
//           </p>
//           <h2 className="text-3xl md:text-4xl font-bold mb-3">
//             What We Offer
//           </h2>
//           <p className="text-gray-300 max-w-2xl mx-auto">
//             A curated lineup of modern, interactive photo booth experiences
//             designed to fit your event style and budget.
//           </p>
//         </div>

//         <div className="grid md:grid-cols-3 gap-7">
//           {services.map((s, i) => (
//             <div
//               key={s.title}
//               className="group bg-white/5 border border-white/10 rounded-3xl p-6 flex flex-col h-full shadow-lg shadow-black/40 hover:shadow-2xl hover:shadow-[#E34364]/30 hover:-translate-y-2 transition-transform duration-300 animate-fade-up"
//               style={{ animationDelay: `${i * 0.08}s` }}
//             >
//               <div className="w-11 h-11 rounded-2xl bg-[#E34364]/20 flex items-center justify-center text-2xl mb-4">
//                 {s.icon}
//               </div>
//               <h3 className="text-lg font-semibold mb-2 group-hover:text-[#E34364] transition">
//                 {s.title}
//               </h3>
//               <p className="text-sm text-gray-300 flex-1">{s.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }


import React, { useState, useEffect } from "react";
import axios from "axios";


export default function ServicesSection() {
  const [services, setServices] = useState([]);
  
  useEffect(() => {
    const API = process.env.REACT_APP_API_URL || 'https://api.pixlybooth.com';
    axios.get(`${API}/api/booths`)
      .then(res => setServices(res.data.booths))
      .catch(err => console.error(err));
  }, []);

  return (
    <section id="services" className="py-20 bg-slate-900 text-white relative">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
            Services
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">What We Offer</h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Modern, interactive booth experiences — built to match your event vibe.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
        <article
  key={s.title}
  className="group rounded-2xl overflow-hidden border border-white/10 bg-white/[0.04]
             shadow-[0_14px_30px_rgba(0,0,0,0.45)]
             hover:shadow-[0_18px_45px_rgba(227,67,100,0.20)]
             transition-all duration-300 animate-fade-up"
  style={{ animationDelay: `${i * 0.06}s` }}
>
  <div className="relative h-52 bg-slate-800">
    {s.image_url && (
      <img
        src={s.image_url}
        alt={s.title}
        className="w-full h-full object-cover"
      />
    )}

    {/* overlays */}
    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/25 to-transparent" />

    {/* badge */}
    {s.badge && (
      <div className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.25em]
                      bg-black/40 border border-white/15 backdrop-blur-md
                      px-3 py-1 rounded-full">
        {s.badge}
      </div>
    )}
  </div>

  {/* CONTENT */}
  <div className="px-6 pt-5 pb-6">
    {/* title row */}
    <div className="flex items-center gap-3 mb-2">
      <div className="w-9 h-9 rounded-xl bg-[#E34364]/20
                      border border-white/15
                      flex items-center justify-center text-lg">
        {s.icon}
      </div>
      <h3 className="text-lg font-semibold text-white">
        {s.title}
      </h3>
    </div>

    {/* description */}
    <p className="text-sm text-gray-300 leading-relaxed mb-4">
      {s.desc}
    </p>

    {/* FEATURES – clean 2 column */}
    <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-[13px] text-gray-200 mb-5">
      {(Array.isArray(s.features) ? s.features : (typeof s.features === 'string' ? JSON.parse(s.features || '[]') : [])).map((f) => (
        <li key={f} className="flex items-start gap-2">
          <span className="mt-[6px] w-1.5 h-1.5 rounded-full bg-[#E34364]" />
          <span>{f}</span>
        </li>
      ))}
    </ul>

    {/* FOOTER ROW */}
    <div className="flex items-center justify-between pt-3 border-t border-white/10">
      <button
        onClick={() =>
          document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })
        }
        className="text-sm font-semibold text-[#E34364] hover:text-pink-400 transition"
      >
        View Packages →
      </button>

      <span className="text-[11px] text-gray-400">
        Instant Sharing • Attendant
      </span>
    </div>
  </div>
</article>

          ))}
        </div>

        {/* Note */}
        <p className="text-center text-xs text-gray-400 mt-10 animate-fade-up">
          Need a custom setup? We can tailor backdrops, overlays, props, and sharing flows.
        </p>
      </div>
    </section>
  );
}
